import { BlogPostCard, type IWordpress } from "@kunduz/feature-blog";
import { BlogBreadcrumb } from "@kunduz/feature-blog";
import { trackEvent } from "@kunduz/utility-analytics";
import { NextSeo } from "next-seo";
import { useEffect } from "react";
import BlogPagination from "../../components/blogPagination";
import pageStyles from "./style.module.scss";
import QuestionSideCtaLoader, {
  SideCTAModes,
} from "../../../../common/components/sideCta";
import {
  WebsiteEnFooter,
  WebsiteTrFooter,
  BlogQIMobileCta,
  HeaderComponent,
} from "@kunduz/feature-landing-pages";
import { type IContent } from "@kunduz/data-access-cms-api";

export default function BlogCategoryPage(props: Props) {
  useEffect(() => {
    trackEvent("Blog Category Page Visited", {
      category: props.category?.seo?.title,
    });
  }, []);

  return (
    <>
      <NextSeo
        title={props.category?.seo?.title}
        description={props.category?.seo?.metaDesc}
        openGraph={{
          url: props.category?.seo?.opengraphUrl,
          type: props.category?.seo?.opengraphType,
          title: props.category?.seo?.opengraphTitle,
          description: props.category?.seo?.opengraphDescription,
          site_name: props.category?.seo?.opengraphSiteName,
        }}
        twitter={{
          handle: props.lang == "en" ? "@askkunduz" : "@kunduzasor",
          cardType: "summary_large_image",
        }}
        robotsProps={{
          maxImagePreview: "large",
        }}
      />

      <HeaderComponent
        language={props.lang}
        headerContactShow={false}
        headerBannerShow={!!props.headerBanner}
        headerBannerData={props.headerBanner}
        headerShow={!!props.headerItems}
        headerItems={props.headerItems}
      />

      {props.lang == "tr" && <BlogQIMobileCta />}

      <div className={pageStyles.pageContainer}>
        <main className={pageStyles.content}>
          <div className={pageStyles.breadcrumb}>
            <BlogBreadcrumb category={props.category} lang={props.lang} />
          </div>

          {props.posts?.map((post, i) => {
            return <BlogPostCard post={post} key={i} lang={props.lang} />;
          })}
        </main>

        <aside className={pageStyles.sidebar}>
          <QuestionSideCtaLoader
            isMobile={props.isMobile}
            lang={props.lang}
            mode={SideCTAModes.BLOG}
            translationFile="kunduzcom_blog"
          />
        </aside>
      </div>

      <BlogPagination pageInfo={props.pageInfo} />

      {props.lang == "tr" ? <WebsiteTrFooter /> : <WebsiteEnFooter />}
    </>
  );
}

interface Props {
  posts: IWordpress.IWordpressCategoryPostResponse["nodes"];
  pageInfo: IWordpress.IWordpressCategoryPostResponse["pageInfo"];
  category: IWordpress.IWordpressCategoryPostResponse["category"];
  headerItems: IContent.HeaderItemsResponse;
  lang: "tr" | "en";
  menuItems: Record<string, any>;
  isMobile: boolean;
  headerBanner?: IContent.HeaderBannerResponse;
}
